import React from "react";
import { CheckCircle2, Clock } from "lucide-react";

interface PedidoProntoRetiradaModalProps {
  customerName: string;
  segundosRestantes: number;
  aguardandoDepoisEste?: number;
}

export const PedidoProntoRetiradaModal: React.FC<
  PedidoProntoRetiradaModalProps
> = ({ customerName, segundosRestantes, aguardandoDepoisEste = 0 }) => {
  const nome =
    typeof customerName === "string" && customerName.trim()
      ? customerName.trim()
      : "Cliente";

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/90 p-4 sm:p-6">
      <div
        role="dialog"
        aria-labelledby="titulo-retirada-pronto"
        aria-live="polite"
        aria-atomic="true"
        className="w-full max-w-4xl rounded-3xl border-4 border-green-400 bg-gradient-to-br from-green-950 via-green-900 to-primary px-6 py-8 shadow-[0_0_40px_rgba(74,222,128,0.35)] sm:rounded-[2rem] sm:px-12 sm:py-10 md:border-[6px] md:px-16 md:py-14"
      >
        <div className="mb-6 flex flex-col items-center gap-4 sm:mb-8">
          <div className="flex text-6xl drop-shadow-xl sm:text-7xl lg:text-8xl">
            <span className="animate-bounce" aria-hidden>
              🍕
            </span>
          </div>
          <CheckCircle2
            className="shrink-0 text-green-300 drop-shadow"
            size={48}
            aria-hidden
            strokeWidth={2.5}
          />
        </div>
        <h2
          id="titulo-retirada-pronto"
          className="mb-2 text-center text-2xl font-black uppercase tracking-wide text-yellow-300 drop-shadow sm:text-4xl lg:text-5xl"
        >
          Pedido pronto para retirar
        </h2>
        <div className="mb-8 rounded-2xl border-2 border-white/30 bg-black/35 px-4 py-5 backdrop-blur-sm sm:mb-10 sm:rounded-3xl sm:border-4 sm:px-8 sm:py-7">
          <p className="text-center text-3xl font-black leading-tight text-white drop-shadow-xl sm:text-5xl lg:text-6xl">
            {nome}
          </p>
          <p className="mt-4 text-center text-lg font-semibold leading-snug text-green-100 sm:text-2xl lg:text-3xl">
            Pode vir buscar seu pedido no balcão.
          </p>
        </div>
        {aguardandoDepoisEste > 0 && (
          <p className="mb-4 text-center text-base font-semibold text-yellow-100/95 sm:text-lg">
            Mais {aguardandoDepoisEste}{" "}
            {aguardandoDepoisEste === 1
              ? "pedido será chamado na sequência."
              : "pedidos serão chamados um por vez em seguida."}
          </p>
        )}
        <div className="flex items-center justify-center gap-3 text-lg font-semibold text-green-200 sm:text-xl">
          <Clock className="h-7 w-7 shrink-0 sm:h-8 sm:w-8" aria-hidden />
          <span>
            Esta mensagem fecha em{" "}
            <span className="tabular-nums">{segundosRestantes}</span> segundo
            {segundosRestantes !== 1 ? "s" : ""}
          </span>
        </div>
      </div>
    </div>
  );
};
